/* PECTO External Reviews — front-end (DE) */
(function () {
  "use strict";

  // ---------- helpers ----------
  function stars(n) {
    n = Number(n || 0);
    let s =
      '<span class="pecto-stars" aria-label="' +
      n +
      ' von 5 Sternen" style="display:inline-flex;gap:4px;vertical-align:middle">';
    for (let i = 1; i <= 5; i++) {
      s +=
        `<svg viewBox="0 0 20 20" width="18" height="18" style="fill:${i <= n ? '#FD6506' : '#ddd'}">` +
        `<path d="M10 15l-5.878 3.09 1.123-6.545L.49 6.91l6.562-.954L10 0l2.948 5.956 6.562.954-4.755 4.635 1.123 6.545z"/></svg>`;
    }
    return s + "</span>";
  }

  function esc(str) {
    return String(str || "").replace(/</g, "&lt;");
  }

  function renderList(items) {
    if (!items || !items.length) {
      return `<p>Noch keine externen Bewertungen gefunden.</p>`;
    }
    return items
      .map((it) => {
        const title = it.title ? `<strong style="margin-left:6px">${esc(it.title)}</strong>` : "";
        const when = it.created_at ? new Date(it.created_at).toLocaleDateString("de-AT") : "";
        const vp = it.verified_purchase
          ? `<span class="pecto-vp" title="Vom System als verifizierter Kauf bestätigt" aria-label="Verifizierter Kauf" style="display:inline-flex;align-items:center;gap:4px;margin-left:8px;font-size:.85rem;color:#2B4455">
               <svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true"><path d="M10 0l8 3v6c0 5.25-3.44 8.9-8 11-4.56-2.1-8-5.75-8-11V3l8-3zM9 13l6-6-1.4-1.4L9 10.2 6.4 7.6 5 9l4 4z" fill="currentColor"/></svg>
               Verifizierter Kauf
             </span>`
          : "";

        const source =
          it.source || it.source_url
            ? `<span style="margin-left:8px;color:#2B4455;font-size:.9rem">
                 Quelle: ${
                   it.source_url
                     ? `<a href="${esc(it.source_url)}" target="_blank" rel="noopener" style="color:#2B4455;text-decoration:underline">${esc(it.source || 'Externe Seite')}</a>`
                     : esc(it.source || "")
                 }
               </span>`
            : "";

        const body = esc(it.body).replace(/\n/g, "<br>");

        return `<div class="pecto-review-item" style="border-bottom:1px solid #eee;padding:12px 0">
          <div>${stars(it.rating)} ${title} ${vp}</div>
          <div style="color:#666;font-size:.9rem;margin:2px 0">${when}${source ? " · " + source : ""}</div>
          <div>${body}</div>
        </div>`;
      })
      .join("");
  }

  async function load(root) {
    const API = root.dataset.api || "";
    const handle = root.dataset.productHandle || root.dataset.handle || "";
    const limit = Number(root.dataset.limit || 50);

    if (!API || !handle) {
      root.innerHTML = `<p>Externe Bewertungen momentan nicht verfügbar.</p>`;
      return;
    }

    root.innerHTML = `<div style="color:#666">Lade externe Bewertungen…</div>`;

    const res = await fetch(
      `${API}/external-reviews?handle=${encodeURIComponent(handle)}&limit=${limit}`
    )
      .then((r) => r.json())
      .catch(() => ({ ok: false }));

    if (!res || !res.ok) {
      root.innerHTML = `<p>Externe Bewertungen momentan nicht verfügbar.</p>`;
      return;
    }

    root.innerHTML = renderList(res.items || []);
  }

  function init() {
    const root = document.getElementById("pecto-external-reviews-root");
    if (root) load(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
